export default {
  namespaced: true,

  state: {
    visible: false,
    message: "",
    type: "info", // "info" | "warning" | "error"
  },

  mutations: {
    SHOW(state, { message, type }) {
      state.visible = true;
      state.message = message;
      state.type = type || "info";
    },
    HIDE(state) {
      state.visible = false;
      state.message = "";
      state.type = "info";
    }
  },

  actions: {
    show({ commit }, { message, type }) {
      commit("SHOW", { message, type });
      const duration = type === "warning" || type === "error" ? 4000 : 3000;
      setTimeout(() => {
        commit("HIDE");
      }, duration);
    },
    hide({ commit }) {
      commit("HIDE");
    }
  },

  getters: {
    isVisible: (s) => s.visible,
    message: (s) => s.message,
    type: (s) => s.type,
  }
};
